import { readingTime } from 'reading-time-estimator'

/* eslint-disable no-undef */
import './navigation-drawer'
import './navigation-dropdown'
import './cookies'

// Arrow Up Icon Button
const arrowUpIcon = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.83301 14.1667L14.1663 5.83334M14.1663 5.83334H5.83301M14.1663 5.83334V14.1667" stroke="#05A6F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document
  .querySelectorAll('.btn.contents__blog--cardReadMoreBtn')
  .forEach((el) => {
    el.innerHTML += arrowUpIcon
  })
const bookDemoBtn = document.querySelector('.btn.btn-book-demo')
if (bookDemoBtn) {
  bookDemoBtn.innerHTML += arrowUpIcon
}

const chevronDownIcon = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 4.5L6 7.5L9 4.5" stroke="#94A3B8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

document.querySelectorAll('.link-item .arrow-down').forEach((el) => {
  el.innerHTML += chevronDownIcon
})

const hamburgerIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12H21M3 6H21M3 18H21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const hamburgerBtn = document.querySelector('.btn-hamburger')
if (hamburgerBtn) {
  hamburgerBtn.innerHTML += hamburgerIcon
}



// Environment Variable Setup
let rawStrapiUrl =
  process.env.VERCEL_STRAPI_URL &&
  process.env.VERCEL_STRAPI_URL !== 'undefined'
    ? process.env.VERCEL_STRAPI_URL
    : 'https://blogger.wenodo.com/'

rawStrapiUrl = rawStrapiUrl.replace(/\/+$/, '')
if (rawStrapiUrl.endsWith('/api')) {
  rawStrapiUrl = rawStrapiUrl.slice(0, -4)
}

const STRAPI_URL = rawStrapiUrl
const STRAPI_TOKEN = process.env.VERCEL_STRAPI_TOKEN || ''
const BASE_URL =
  process.env.VERCEL_BASE_URL && process.env.VERCEL_BASE_URL !== 'undefined'
    ? process.env.VERCEL_BASE_URL
    : ''

// Get Data Strapi
const myHeaders = new Headers()
if (STRAPI_TOKEN) {
  myHeaders.append('Authorization', `Bearer ${STRAPI_TOKEN}`)
}

const requestOptions = {
  method: 'GET',
  headers: myHeaders,
  redirect: 'follow',
}

function resolveRichText(nodes) {
  if (!Array.isArray(nodes)) return ''
  return nodes.map((c) => resolveRichTextNode(c)).join('')
}

function resolveRichTextNode(node) {
  if (!node) return ''
  let html = ''
  const children = Array.isArray(node.children)
    ? node.children.map((c) => resolveRichTextNode(c)).join('')
    : ''

  switch (node.type) {
    case 'heading':
      html = `<h${node.level || 1}>${children}</h${node.level || 1}>`
      break
    case 'text':
      if (node.text) {
        let tmp = node.text.replaceAll('\n', '<br />')

        if (node.bold) tmp = `<b>${tmp}</b>`
        if (node.code) tmp = `<code>${tmp}</code>`
        if (node.italic) tmp = `<i>${tmp}</i>`
        if (node.strikethrough) tmp = `<s>${tmp}</s>`
        if (node.underline) tmp = `<u>${tmp}</u>`

        html = tmp
      }
      break
    case 'paragraph':
      html = `<p>${children}</p>`
      break
    case 'link':
      html = `<a href="${node.url || '#'}">${children}</a>`
      break
    case 'list':
      switch (node.format) {
        case 'ordered':
          html = `<ol>${children}</ol>`
          break
        case 'unordered':
        default:
          html = `<ul>${children}</ul>`
          break
      }
      break
    case 'list-item':
      html = `<li>${children}</li>`
      break
    case 'quote':
      html = `<blockquote>${children}</blockquote>`
      break
    case 'code':
      html = `<pre>${children}</pre>`
      break
    case 'image':
      if (node.image?.url) {
        html = `<img src="${node.image.url}" height="${node.image.height || ''}" width="${node.image.width || ''}" alt="${node.image.alternativeText || ''}" />`
      }
      break
  }

  return html
}

function formatTitleSlug(title) {
  if (!title) return ''
  return title.replaceAll(':', '').replaceAll(' ', '-')
}

function getCoverUrl(coverData) {
  const url = coverData?.data?.attributes?.url
  if (!url) return ''
  return url.replace('/upload', '/upload/q_auto:eco').replace('.png', '.webp')
}

function getBlogSlug(data, id) {
  if (data?.slug) return data.slug
  const title = data?.Title || data?.title
  if (title) {
    return title
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
  }
  return id || ''
}

const featuredBlogHero = (datas) => {
  if (!Array.isArray(datas) || datas.length === 0) return
  const data = datas[0]?.attributes || datas[0]
  if (!data) return
  const heroElement = document.querySelector('.hero__blog--featured')
  if (!heroElement) return

  const titleEl = heroElement.querySelector('[data-element="hero-blog-title-featured"]')
  if (titleEl) titleEl.innerHTML = data.Title || data.title || ''

  const descEl = heroElement.querySelector('[data-element="hero-blog-desc-featured"]')
  if (descEl) descEl.innerHTML = data.Detail || data.summary || ''

  const slug = getBlogSlug(data, datas[0].id)
  const linkEl = heroElement.querySelector('[data-element="hero-blog-desc-url-link"]')
  if (linkEl) {
    linkEl.setAttribute(
      'onclick',
      `location.href = "${BASE_URL}/blog-detail.html/${slug}";`,
    )
  }
}

const featuredLargeBlog = (datas) => {
  if (!Array.isArray(datas) || datas.length === 0) return
  const data = datas[0]?.attributes || datas[0]
  if (!data) return
  const cardElement = document.querySelector(
    '.contents__blog--card.featuredLarge[data-element="blog-card"]',
  )
  if (!cardElement) return

  const slug = getBlogSlug(data, datas[0].id)
  const detailUrl = `${BASE_URL}/blog-detail.html/${slug}`

  const linkImg = cardElement.querySelector('[data-element="url-link-image"]')
  if (linkImg) {
    linkImg.setAttribute('href', detailUrl)
    const img = linkImg.querySelector('img')
    if (img) img.src = getCoverUrl(data.cover || data.coverImage || data.ogImage)
  }

  const createdDate = cardElement.querySelector('[data-element="created-date"]')
  const pubDate = data.publishedAt || data.createdAt
  if (createdDate && pubDate) {
    createdDate.innerHTML = moment(pubDate).format('MMM. DD,Y')
  }

  const readingTimeEl = cardElement.querySelector('[data-element="reading-time"]')
  const contents = data.contents || data.content || data.Detail || data.summary
  if (readingTimeEl && contents) {
    const textContent = typeof contents === 'string' ? contents : resolveRichText(contents)
    readingTimeEl.innerHTML = readingTime(textContent, 300).text
  }

  const titleEl = cardElement.querySelector('[data-element="title"]')
  if (titleEl) titleEl.innerHTML = data.Title || data.title || ''

  const descEl = cardElement.querySelector('[data-element="description"]')
  if (descEl) descEl.innerHTML = data.Detail || data.summary || ''

  const readMoreLink = cardElement.querySelector('[data-element="readMore-link"]')
  if (readMoreLink) {
    readMoreLink.setAttribute('href', detailUrl)
  }
}

const featuredSmallsBlog = (datas) => {
  if (!Array.isArray(datas)) return
  const featuredSmalls = document.querySelector(
    '.contents__blog--featuredSmalls',
  )
  if (!featuredSmalls) return

  const _datas = datas.slice(1, 4)
  _datas.forEach((_data) => {
    const data = _data?.attributes || _data
    if (!data) return
    const templateCard = featuredSmalls.querySelector('[data-element="blog-card"]')
    if (!templateCard) return
    const cardElement = templateCard.cloneNode(true)

    const slug = getBlogSlug(data, _data.id)
    const detailUrl = `${BASE_URL}/blog-detail.html/${slug}`

    const urlLinkImg = cardElement.querySelector('[data-element="url-link-image"]')
    if (urlLinkImg) {
      urlLinkImg.setAttribute('href', detailUrl)
      const img = urlLinkImg.querySelector('img')
      if (img) img.src = getCoverUrl(data.cover || data.coverImage || data.ogImage)
    }

    const createdDate = cardElement.querySelector('[data-element="created-date"]')
    const pubDate = data.publishedAt || data.createdAt
    if (createdDate && pubDate) {
      createdDate.innerHTML = moment(pubDate).format('MMM. DD,Y')
    }

    const readingTimeEl = cardElement.querySelector('[data-element="reading-time"]')
    const contents = data.contents || data.content || data.Detail || data.summary
    if (readingTimeEl && contents) {
      const textContent = typeof contents === 'string' ? contents : resolveRichText(contents)
      readingTimeEl.innerHTML = readingTime(textContent, 300).text
    }

    const titleEl = cardElement.querySelector('[data-element="title"]')
    if (titleEl) titleEl.innerHTML = data.Title || data.title || ''

    const descEl = cardElement.querySelector('[data-element="description"]')
    if (descEl) descEl.innerHTML = data.Detail || data.summary || ''

    const readMoreLink = cardElement.querySelector('[data-element="readMore-link"]')
    if (readMoreLink) {
      readMoreLink.setAttribute('href', detailUrl)
    }

    featuredSmalls.appendChild(cardElement)
  })

  const cards = featuredSmalls.querySelectorAll('[data-element="blog-card"]')
  if (cards.length > 0) cards[0].remove()
}

const gridListBlogs = (datas) => {
  if (!Array.isArray(datas)) return
  const gridBlogs = document.querySelector('.contents__blog--cards')
  if (!gridBlogs) return

  const _datas = datas.slice(4)
  _datas.forEach((_data) => {
    const data = _data?.attributes || _data
    if (!data) return
    const templateCard = gridBlogs.querySelector('[data-element="blog-card"]')
    if (!templateCard) return
    const cardElement = templateCard.cloneNode(true)

    const slug = getBlogSlug(data, _data.id)
    const detailUrl = `${BASE_URL}/blog-detail.html/${slug}`

    const urlLinkImg = cardElement.querySelector('[data-element="url-link-image"]')
    if (urlLinkImg) {
      urlLinkImg.setAttribute('href', detailUrl)
      const img = urlLinkImg.querySelector('img')
      if (img) img.src = getCoverUrl(data.cover || data.coverImage || data.ogImage)
    }

    const createdDate = cardElement.querySelector('[data-element="created-date"]')
    const pubDate = data.publishedAt || data.createdAt
    if (createdDate && pubDate) {
      createdDate.innerHTML = moment(pubDate).format('MMM. DD,Y')
    }

    const readingTimeEl = cardElement.querySelector('[data-element="reading-time"]')
    const contents = data.contents || data.content || data.Detail || data.summary
    if (readingTimeEl && contents) {
      const textContent = typeof contents === 'string' ? contents : resolveRichText(contents)
      readingTimeEl.innerHTML = readingTime(textContent, 300).text
    }

    const titleEl = cardElement.querySelector('[data-element="title"]')
    if (titleEl) titleEl.innerHTML = data.Title || data.title || ''

    const descEl = cardElement.querySelector('[data-element="description"]')
    if (descEl) descEl.innerHTML = data.Detail || data.summary || ''

    const readMoreLink = cardElement.querySelector('[data-element="readMore-link"]')
    if (readMoreLink) {
      readMoreLink.setAttribute('href', detailUrl)
    }

    gridBlogs.appendChild(cardElement)
  })

  const cards = gridBlogs.querySelectorAll('[data-element="blog-card"]')
  if (cards.length > 0) cards[0].remove()
}

const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
const page = urlParams.get('page') ?? 1
const category = urlParams.get('category') ?? ''
const currentCategory = category || 'blog-articles'

const createElementPagination = (pagination) => {
  if (!pagination) return
  const blogPagination = document.querySelector('[data-element="pagination"]')
  if (!blogPagination) return
  const paginationGroup = blogPagination.querySelector(
    '[data-element="pagination-group"]',
  )
  if (!paginationGroup) return

  for (let index = 0; index < (pagination.pageCount || 0); index++) {
    const templateBtn = blogPagination.querySelector('[data-element="pagination-button"]')
    if (!templateBtn) break
    const paginationButton = templateBtn.cloneNode(true)
    paginationButton.textContent = index + 1
    const pParams = new URLSearchParams(window.location.search)
    pParams.set('page', index + 1)
    paginationButton.setAttribute(
      'onclick',
      `window.location.href="${BASE_URL}/blog.html?${pParams.toString()}#blogContent";`,
    )
    paginationGroup.appendChild(paginationButton)
  }

  if (pagination.page > 1) {
    const leftParams = new URLSearchParams(window.location.search)
    leftParams.set('page', pagination.page - 1)
    const leftBtn = blogPagination.querySelector('[data-element="pagination-left"]')
    if (leftBtn) {
      leftBtn.setAttribute(
        'onclick',
        `window.location.href="${BASE_URL}/blog.html?${leftParams.toString()}#blogContent";`,
      )
    }
  }
  if (pagination.page === 1) {
    const leftBtn = blogPagination.querySelector('[data-element="pagination-left"]')
    if (leftBtn) leftBtn.classList.add('disabled')
  }

  if (pagination.page < pagination.pageCount) {
    const rightParams = new URLSearchParams(window.location.search)
    rightParams.set('page', pagination.page + 1)
    const rightBtn = blogPagination.querySelector('[data-element="pagination-right"]')
    if (rightBtn) {
      rightBtn.setAttribute(
        'onclick',
        `window.location.href="${BASE_URL}/blog.html?${rightParams.toString()}#blogContent";`,
      )
    }
  }
  if (pagination.page === pagination.pageCount) {
    const rightBtn = blogPagination.querySelector('[data-element="pagination-right"]')
    if (rightBtn) rightBtn.classList.add('disabled')
  }

  const buttons = blogPagination.querySelectorAll('[data-element="pagination-button"]')
  if (buttons.length > 0) buttons[0].remove()
  const activeBtn = blogPagination.querySelectorAll('[data-element="pagination-button"]')[pagination.page - 1]
  if (activeBtn) activeBtn.classList.add('active')
}

// Set active tab and attach click handlers
document.querySelectorAll('[data-element="blog-tabs"] button').forEach((el) => {
  const tabCategory = el.getAttribute('data-element')
  if (tabCategory === currentCategory) {
    el.classList.add('active')
  } else {
    el.classList.remove('active')
  }

  el.addEventListener('click', () => {
    window.location.href = `${BASE_URL}/blog.html?category=${tabCategory}#blogContent`
  })
})

// Query CMS API (only filter if category is specified and not the main 'blog-articles' tab)
let categoryFilterParam = ''
if (category && category !== 'blog-articles') {
  categoryFilterParam = `&search=${encodeURIComponent(category)}`
}

const primaryUrl = `${STRAPI_URL}/api/blogs?page=${page}&pageSize=13${categoryFilterParam}`

fetch(primaryUrl, requestOptions)
  .then((response) => (response.ok ? response.json() : null))
  .then((result) => {
    if (!result?.data || result.data.length === 0) {
      const notFound = document.querySelector('[data-element="blog-not-found"]')
      if (notFound) notFound.style.display = 'block'
      const paginationEl = document.querySelector('[data-element="pagination"]')
      if (paginationEl) paginationEl.style.display = 'none'
    } else {
      const notFound = document.querySelector('[data-element="blog-not-found"]')
      if (notFound) notFound.style.display = 'none'

      featuredBlogHero(result.data)
      featuredLargeBlog(result.data)
      featuredSmallsBlog(result.data)
      gridListBlogs(result.data)

      if (result.meta?.pagination) {
        createElementPagination(result.meta.pagination)
      }

      document.querySelectorAll('[data-element="blog-card"]').forEach((el) => {
        el.style.display = 'flex'
      })
      const paginationEl = document.querySelector('[data-element="pagination"]')
      if (paginationEl) paginationEl.style.display = 'flex'
    }
  })
  .catch((error) => console.error('Error fetching blogs:', error))

// Dropdown Product
const dropdownProduct = document.querySelector(
  '[data-element="dropdown-product"]',
)
if (dropdownProduct) {
  const dropdownBtn = dropdownProduct.querySelector('[data-element="dropdown-btn"]')
  if (dropdownBtn) {
    dropdownBtn.addEventListener('click', () => {
      const dropdownContent = dropdownProduct.querySelector('[data-element="dropdown-content"]')
      const arrow = dropdownProduct.querySelector('[data-element="dropdown-btn-arrow"]')
      if (dropdownContent) {
        if (dropdownContent.classList.contains('hide')) {
          dropdownContent.classList.remove('hide')
          if (arrow) arrow.style.rotate = '180deg'
        } else {
          dropdownContent.classList.add('hide')
          if (arrow) arrow.style.rotate = '0deg'
        }
      }
    })
  }

  dropdownProduct
    .querySelectorAll('[data-element="dropdown-btn-item"]')
    .forEach((elBtn) => {
      const itemSelect = elBtn.getAttribute('data-select')
      if (itemSelect === currentCategory) {
        const textP = dropdownProduct.querySelector('[data-element="dropdown-btn"] p')
        if (textP) textP.textContent = elBtn.querySelector('p')?.textContent || ''
      }

      elBtn.addEventListener('click', () => {
        const textSelection = elBtn.querySelector('p')?.textContent || ''
        const textP = dropdownProduct.querySelector('[data-element="dropdown-btn"] p')
        if (textP) textP.textContent = textSelection

        const dropdownContent = dropdownProduct.querySelector('[data-element="dropdown-content"]')
        if (dropdownContent) dropdownContent.classList.add('hide')
        const arrow = dropdownProduct.querySelector('[data-element="dropdown-btn-arrow"]')
        if (arrow) arrow.style.rotate = '0deg'

        window.location.href = `${BASE_URL}/blog.html?category=${itemSelect}#blogContent`
      })
    })
}
